import ROLES from '../../utils/roles';
export default {
  /**
   * @description setToken 设置token
   */
  setToken: (state, data) => {
    let role = data.role;
    state[`${role}_TOKEN`] = data.token;
    localStorage.setItem(`${role}_TOKEN`, data.token);
  },
  /**
   * @description setLastLoginType 设置最后登录的角色
   */
  setLastLoginType: (state, role) => {
    state.lastLoginType = role;
    localStorage.LAST_LOGIN_ROLE = state.lastLoginType;
  },
  /**
   * @description setLoginData 设置登录信息
   */
  setLoginData: (state, data) => {
    let role = data.role;
    switch (role) {
      case ROLES.STUDENT: {
        state.studentLoginData = data.data;
        break;
      }
      case ROLES.TEACHER: {
        state.teacherLoginData = data.data;
        break;
      }
      case ROLES.SCHOOL: {
        state.schoolLoginData = data.data;
        break;
      }
      case ROLES.SL: {
        state.slLoginData = data.data;
        break;
      }
    }
  },
  cleanToken: (state, role) => {
    state[`${role}_TOKEN`] = '';
    localStorage.removeItem(`${role}_TOKEN`);
  },
  /**
   * @description cleanLoginData 清空登录数据
   */
  cleanLoginData: (state, role) => {
    switch (role) {
      case ROLES.STUDENT: {
        state.studentLoginData = {};
        break;
      }
      case ROLES.TEACHER: {
        state.teacherLoginData = {};
        break;
      }
      case ROLES.SCHOOL: {
        state.schoolLoginData = {};
        break;
      }
      case ROLES.SL: {
        state.slLoginData = {};
        break;
      }
      default: {
        state.studentLoginData = {};
        state.teacherLoginData = {};
        state.schoolLoginData = {};
        state.slLoginData = {};
        break;
      }
    }
  },
  cleanLastLoginType: state => {
    state.lastLoginType = '';
    localStorage.LAST_LOGIN_ROLE = state.lastLoginType;
  },
  /**
   * @description 设置学生状态数据
   * @function setStudentStatus
   * @param {Object} state vuex state
   * @param {Object} status 状态数据
   */
  setStudentStatus: (state, status) => {
    state.studentStatus = status;
  },
  triggerWelfare: state => {
    state.isShowWelfare = !state.isShowWelfare;
  },
  setComData: (state, data) => {
    state.comData = data;
  },
  setComDataReset: (state, data) => {
    state.comDataReset = data;
  }
};
